import { AdminBarberRepository } from "../../Repository";

export async function cancelSubscription(
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.cancelSubscription();
}
